var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 1,
    y: 3,
    width: 14,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.5V13A1.5 1.5 0 005 14.5h6a1.5 1.5 0 001.5-1.5V3.5h-9z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1a1 1 0 011 1v2H7V2a1 1 0 011-1z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 6,
    y: 6,
    width: 1,
    height: 6,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 9,
    y: 6,
    width: 1,
    height: 6,
    rx: 0.5
  }))));
}
export default SvgDelete;